











import { Component, Vue } from 'vue-property-decorator';
import { getAccount } from '@/utils/user';
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
import en_US from 'ant-design-vue/lib/locale-provider/en_US';
import moment from 'moment';
import 'moment/locale/zh-cn';
import 'moment/locale/en-gb';
import { AccountModule } from '@/store/modules/account';
import { AppModule } from './store/modules/app';
import { aesDecrypt } from './utils/other';
import {offSignalR, startSignalR} from './utils/signalr';

@Component
export default class App extends Vue {
  private logined: boolean = false;
  get locale() {
    if (AppModule.language === 'zh') {
      moment.locale('zh-cn');
      return zh_CN;
    } else {
      moment.locale('en-gb');
      return en_US;
    }
  }
  private created() {
    startSignalR();
    const account = getAccount();
    if (account && account.mobile && account.pw) {
      AccountModule.Login({
        mobile: account.mobile,
        password: aesDecrypt(account.pw),
      })
      .then((res) => {
        this.logined = true;
      })
      .catch((error) => {
        this.logined = true;
        AccountModule.Logout();
        location.replace('/');
      });
    } else {
      this.logined = true;
      this.$router.push({ name: 'Login' });
    }
  }
  private beforeDestroy() {
    offSignalR();
  }
}
